module.exports = __webpack_public_path__ + "media/numbers/three-f0aab36b.svg";